import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds'
import { RouteConfig } from 'vue-router'

const rotasDeMonitoramentoBanco: RouteConfig[] = [
	{
		path: 'monitoramento-banco',
		name: 'Monitoramento de Banco de Dados',
		components: {
			default: () =>
			import('@/views/application/configuracoes/monitoramento-banco/TelaDeMonitoramentoBanco.vue'),
			toolbar: () =>
			import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
	},
]

export default rotasDeMonitoramentoBanco
